import React, {Component} from "react";

class Landing extends Component {
	render() {
		return (
			<div className={"landing"}>
				<h1>Welcome to Arcricket</h1>
				<h3>The online scoreboard for weekly cricket games</h3>
				<br/>
				<br/>
				<br/>
				<br/>
				<h5>Probably gonna be some stuff here in the future</h5>
			</div>
		);
	}
}

export default Landing;
